import React, { useEffect, useState } from "react"
import { useCssStyle } from "../../../../customHook/getCssStyle"
import HeaderWithBack from "../../../../components/Header/headerWithBack";
import { ScrollView, StyleSheet, Text, TextInput, View } from "react-native";
import { useTranslation } from "react-i18next";
import { CHECKIN_DEMO_FLOW, DEMO_FLOW_ENABLED, MOBILE_CHECKIN_CATEGORY } from "../../../../config/Constant";
import CustomPressable from "../../../../components/customPressable/customPressable";
import { useDispatch } from "react-redux";
import { setRenderFlashMessage } from "../../../../Redux/Actions/appConfigAction";
import FetchingDataScreen from "../../../../components/fetchingDataScreen";
import { cardValidation } from "../../../../Redux/Actions/checkInAction";
import InfoPopupModal from "../../../../components/infoPopupModal";
import { ElavonCardContainerModal } from "./elavonCardContainerModal";
import { CustomTextInput } from "../../../../components/customTextInput";
import { sendAnalytics } from "../../../../Redux/Actions/analyticsAction";

export const ElavonCardValidation = ({checkinSessionToken, guestDetails, isCardVerified, handleSetCardVerified, handleGoBack, handleCustomCancelClick, handleNext, handleSkip }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const [loaderState, setLoaderState] = useState({
        isVisible: false,
        message: ""
    });

    const [errorState, setErrorState] = useState({
        errorStatus: false,
        errorMessage: ""
    })

    const [cardModalStatus, setCardModalStatus] = useState({
        enableCardModal: false,
        sessionUrl: ""
    })

    const updateLoaderState = (state, msg) => {
        if (state) {
            setLoaderState({ isVisible: true, message: msg });
        } else {
            setLoaderState({ isVisible: false, message: "" });
        }
    }

    const updateErrorState = (state, msg) => {
        if (state) {
            setErrorState({ errorStatus: true, errorMessage: msg });
        } else {
            setErrorState({ errorStatus: false, errorMessage: "" });
        }
    }

    const updateCardModalStatus = (status, url) => {
        if (status) {
            setCardModalStatus({ enableCardModal: true, sessionUrl: url });
        } else {
            setCardModalStatus({ enableCardModal: false, sessionUrl: "" });
        }
    }

    const [localGuestDetails, setLocalGuestDetails] = useState(() => ({
        firstName: guestDetails?.firstName || "",
        lastName: guestDetails?.lastName || "",
        address: {
            addressLine1: guestDetails?.address?.addressLine1 || "",
            postalCode: guestDetails?.address?.postalCode || "",
        }
    }));

    const updateLocalGuestDetails = (key, value) => {
        setLocalGuestDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };


    const updateAddressDetails = (key, value) => {
        setLocalGuestDetails(prevState => ({
            ...prevState,
            address: {
                ...prevState.address,
                [key]: value
            }
        }));
    };


    const handleCardValidationSuccess = async (response) => {

        updateCardModalStatus(false);

        updateLoaderState(true, "Validating card info...")

        const cardValidationPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
            "cardDigits": response.ssl_card_number.slice(12, 17),
            "firstNameCard": response.ssl_first_name,
            "lastNameCard": response.ssl_last_name,
            "cardCheckId": response.ssl_partner_app_id,
            "transactionType": "ccverify",
            "vaultedCardId": response.ssl_token,
            "cardTypeCode": response.ssl_card_short_description,
            "expiryDate": response.ssl_exp_date
        }

        const checkingCardInfoAsPerBooking = await cardValidation("checks", cardValidationPayload);

        if (checkingCardInfoAsPerBooking.success) {
            updateLoaderState(true, "Updating card details for the booking...");

            const updateCardInfo = await cardValidation("cardUpdate", cardValidationPayload);
            updateLoaderState(false);

            if (updateCardInfo.success) {
                console.log("card validation successfull");
                handleSetCardVerified(true);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken }));
            } else {
                updateErrorState(true, updateCardInfo.message || "Something went wrong");
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": updateCardInfo.message || "Error during card validation: cardUpdate" }));
            }

        } else {
            updateLoaderState(false);
            updateErrorState(true, checkingCardInfoAsPerBooking.message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": checkingCardInfoAsPerBooking.message || "Error during card validation: checks" }));
        }
    }


    const handleCardValidationError = (errorMessage) => {

        updateCardModalStatus(false)

        setTimeout(() => {
            updateErrorState(true, errorMessage || "Something went wrong");
        }, 10);
    }


    const initiateCardValidation = async () => {
        if (!localGuestDetails.firstName.trim()) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter your first name" }));
            return;
        }

        if (!localGuestDetails.lastName.trim()) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter your last name" }));
            return;
        }

        if (!localGuestDetails.address.addressLine1.trim()) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter your address" }));
            return;
        }


        if (!/^[a-zA-Z0-9, .]+$/.test(localGuestDetails.address.addressLine1)) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please note that only English letters and numbers are accepted for the address" }));
            return;
        }

        if (!localGuestDetails.address.postalCode.trim()) {
            dispatch(setRenderFlashMessage(true, { type: "danger", message: "Please enter your postal code" }));
            return;
        }

        updateLoaderState(true, "Preparing card info container...")


        const cardValidationRegisterPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
            "firstNameCard": localGuestDetails.firstName,
            "lastNameCard": localGuestDetails.lastName,
            "transactionType": "ccverify"
        }

        const { success, data, message } = await cardValidation("register", cardValidationRegisterPayload);

        updateLoaderState(false);

        if (success && data.tokenStr) {

            let cardModalUrl = `https://guest-journey.s3.amazonaws.com/static/lightbox.html?token=${data.tokenStr}&address=${localGuestDetails.address.addressLine1}&zip=${localGuestDetails.address.postalCode}`
            updateCardModalStatus(true, cardModalUrl)
        } else {
            updateErrorState(true, message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message || "Error during card validation: register" }));
        }

    };

    useEffect(() => {
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS", { "element": "widget", "widgetSessionId": checkinSessionToken}));

        // eslint-disable-next-line
    },[])


    return (
        <View style={getStyles(['widgetRootContainer', 'cardValidationRootContainer'])} showsVerticalScrollIndicator={0}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCustomCancelClick} />

            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'cardValidationMainContainer'])} showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerHeaderContainer', 'cardValidationHeaderContainer'])}>
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'cardValidationHeaderTitleContainer'])}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'cardValidationHeaderTitle'])}>{t('check_in.card_validation.heading')}</Text>
                        {t('check_in.card_validation.sub_heading') && <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'cardValidationHeaderSubTitle'])}>{t('check_in.card_validation.sub_heading')}</Text>}
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'cardValidationMainContainerChildContainer'])}>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('check_in.card_validation.first_name')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={localGuestDetails.firstName}
                            onChangeText={(value) => updateLocalGuestDetails('firstName', value)}
                            placeholder={t('check_in.card_validation.first_name_placeholder')}
                            autocomplete={"given-name"}
                        />
                    </View>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('check_in.card_validation.last_name')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={localGuestDetails.lastName}
                            onChangeText={(value) => updateLocalGuestDetails('lastName', value)}
                            placeholder={t('check_in.card_validation.last_name_placeholder')}
                            autocomplete={"family-name"}
                        />
                    </View>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('check_in.card_validation.addressLine1')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={localGuestDetails.address.addressLine1}
                            onChangeText={(value) => updateAddressDetails('addressLine1', value)}
                            placeholder={t('check_in.card_validation.addressLine1_placeholder')}
                            autocomplete={"address-line1"}
                        />
                    </View>

                    <View style={getStyles(['textContainer'])}>
                        <Text style={getStyles(['label'])}>{t('check_in.card_validation.postalCode')} <Text style={getStyles(['requiredText'])}>*</Text></Text>
                        <CustomTextInput
                            value={localGuestDetails.address?.postalCode}
                            onChangeText={(value) => updateAddressDetails('postalCode', value)}
                            placeholder={t('check_in.card_validation.postalCode_placeholder')}
                            autocomplete={"postal-code"}
                        />
                    </View>


                    <View style={getStyles(['cardValidationChildContainer_buttonContainer'])}>

                        <CustomPressable style={getStyles(['primaryBtn'])} disabled={loaderState.isVisible} onPress={initiateCardValidation}>
                            <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.card_validation.primary_button')}</Text>
                        </CustomPressable>

                        {(DEMO_FLOW_ENABLED || CHECKIN_DEMO_FLOW) &&
                            <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleSkip}>
                                <Text style={getStyles(['secondaryBtnTxt'])}>{t('check_in.card_validation.skip')}</Text>
                            </CustomPressable>
                        }
                    </View>
                </View>
            </ScrollView>

            { isCardVerified &&
                <InfoPopupModal
                    type={"success"}
                    title={"Card Verified!"}
                    subtitle={"Your card was successfully verified."}
                    onContinue={() => handleNext(localGuestDetails)}
                    primaryBtnLabel={"Next"}
                />
            }

            {cardModalStatus.enableCardModal &&
                <ElavonCardContainerModal
                    checkinSessionToken={checkinSessionToken}
                    handleSuccess={handleCardValidationSuccess}
                    handleError={handleCardValidationError}
                    handleClose={() => updateCardModalStatus(false)}
                    iframeurl={cardModalStatus.sessionUrl}
                />
            }

            {loaderState.isVisible && <FetchingDataScreen loaderMessage={loaderState.message} />}
            {errorState.errorStatus && <InfoPopupModal subtitle={errorState.errorMessage} onContinue={() => updateErrorState(false, "")} primaryBtnLabel={"Close"} OnRequestClose={() =>  updateErrorState(false, "")} />}
        </View>
    )
}